export enum CardStatus {
    failed,
    success,
    notSure,
}


// WEBPACK FOOTER //
// ./src/app/Model/CardStatus.ts